import React from 'react';

import styles from './styles.module.scss';

import ImageBackground from '@components/_shared/imageBackground';
import { TBuyRovePropertyLanding } from '@utils/types/landings';
import Button from '@components/_shared/button';
import { FeaturedListingType } from '@utils/types/featuredListing';
import BuyRovePropertyListingCard from '@components/landing/buyRoveProperty/listingCard';

const BuyRovePropertyHero = (
  props: TBuyRovePropertyLanding['buyRovePropertyHero'] & {
    properties: TBuyRovePropertyLanding['buyRovePropertyProperties'];
    listings: FeaturedListingType[];
  }
) => {
  const { headline, subheadline, cta, properties, listings } = props;

  const onCTAClick = () => {
    const container = document.getElementById('contact');
    window.scrollTo({
      top: (container?.offsetTop || 200) - 200,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <ImageBackground
        containerStyle={styles.hero}
        backgroundImageStyle={`
          linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%),
          url('/images/buy-rove-property-hero-bg.png')
        `}
      >
        <div className={styles.hero__wrapper}>
          <div className={styles.hero__textBlock}>
            <h1 className={styles.hero__headline}>{headline}</h1>
            <div className={styles.hero__subheadline}>{subheadline}</div>
          </div>

          <Button
            onClick={onCTAClick}
            containerStyle={styles.hero__cta}
            variant="greenContained"
          >
            {cta}
          </Button>
        </div>
      </ImageBackground>

      <div className={styles.hero}>
        <div className={styles.hero__propertiesWrapper}>
          <h2 className={styles.hero__title}>{properties.title}</h2>

          <div className={styles.hero__subtitle}>{properties.subtitle}</div>

          <div className={styles.hero__properties}>
            {properties?.properties?.map((property) => {
              const listing = listings.find(
                (listing) =>
                  listing.import_listing_id === property.listing?.guestyId
              )!;
              return (
                <BuyRovePropertyListingCard
                  key={property._key}
                  price={property.price}
                  {...listing}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default BuyRovePropertyHero;
